
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.5 0a3.49 3.49 0 00-1.538 6.628l-3.374 10.431A3.562 3.562 0 0012 17a3.562 3.562 0 00-.588.059L8.038 6.628A3.474 3.474 0 106.5 7a3.562 3.562 0 00.588-.059l3.374 10.431a3.5 3.5 0 103.076 0l3.374-10.431A3.562 3.562 0 0017.5 7a3.5 3.5 0 000-7zM4 3.5A2.5 2.5 0 116.5 6 2.5 2.5 0 014 3.5zm10.5 17A2.5 2.5 0 1112 18a2.5 2.5 0 012.5 2.5zm3-14.5A2.5 2.5 0 1120 3.5 2.5 2.5 0 0117.5 6z"}})])
          )
        }
      }
    